<template>
    <div class="white-container">
        <div class="row">
            <div v-for="(energy, index) in energies" :key="index" class="col-50">
            <ConsommationEnergetiqueInput :energy="energy" v-model="results[energy.label]" @update:modelValue="$emit('update:modelValue', results)"></ConsommationEnergetiqueInput>
            </div>
        </div>
    </div>
</template>
<script>
import ConsommationEnergetiqueInput from '@/components/form/ConsommationEnergetiqueInput.vue'
export default {
    data() {
        return {
            results:{

            },
        }
    },
    props:{
        energies:Array
    },
    components:{
        ConsommationEnergetiqueInput
    }
}
</script>
<style scoped>
@media screen and (max-width: 1000px) {
    .col-50{
        width:100%;
    }
}
</style>